import React, { useMemo } from 'react';

const HEARTS = ['heart-particle'];

function Heart({ size, left, duration, delay, opacity }) {
  return (
    <div
      className={HEARTS[0]}
      aria-hidden="true"
      style={{
        left: `${left}%`,
        bottom: '-5%',
        fontSize: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
        opacity,
      }}
    >
      ♥
    </div>
  );
}

/**
 * BackgroundDecor — renders floating hearts and a soft gradient background.
 */
export default function BackgroundDecor() {
  const hearts = useMemo(
    () =>
      Array.from({ length: 14 }).map((_, i) => ({
        id: i,
        size: 10 + Math.random() * 22,
        left: Math.random() * 100,
        duration: 8 + Math.random() * 10,
        delay: Math.random() * 8,
        opacity: 0.18 + Math.random() * 0.32,
      })),
    []
  );

  return (
    <>
      {/* Gradient background */}
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            'linear-gradient(135deg, #fff1f2 0%, #fce7f3 40%, #ede9fe 80%, #fff5f7 100%)',
        }}
        aria-hidden="true"
      />
      {/* Soft blobs */}
      <div
        className="fixed top-[-10%] left-[-10%] w-72 h-72 rounded-full opacity-30 blur-3xl pointer-events-none -z-10"
        style={{ background: '#fda4af' }}
        aria-hidden="true"
      />
      <div
        className="fixed bottom-[-10%] right-[-10%] w-80 h-80 rounded-full opacity-20 blur-3xl pointer-events-none -z-10"
        style={{ background: '#c4b5fd' }}
        aria-hidden="true"
      />
      {/* Floating hearts */}
      <div
        className="fixed inset-0 overflow-hidden pointer-events-none -z-10"
        aria-hidden="true"
        style={{ color: '#f43f5e' }}
      >
        {hearts.map((h) => (
          <Heart key={h.id} {...h} />
        ))}
      </div>
    </>
  );
}
